module.exports = __webpack_public_path__ + "static/img/41路.b88036f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/41路.jpg
// module id = Gt2h
// module chunks = 2